import { PropsWithChildren } from 'react';

import clsx from 'clsx';

export function Card({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={clsx(
        'flex flex-col gap-4 rounded-xl bg-purple-100 p-6 opacity-80',
        className,
      )}
    >
      {children}
    </div>
  );
}
